import React from 'react';
import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import { F } from '@/utils/intl';

import styles from './index.less';

/**
 * Renders the lead's UUID. The Partner API exposes the lead UUID as the lead
 * `id` (see LeadResource: `'id' => $this->resource->uuid`), so that is the
 * canonical identifier shown here and the same value the CSV export emits in its
 * `uuid` column.
 */
const LeadUuid = ({ lead, isTable }: { lead: LeadModel; isTable?: boolean }) => {
  const uuid = lead?.id;
  const content = uuid ? (
    <Typography.Text copyable={{ text: uuid }} className={styles.uuidText}>
      {uuid}
    </Typography.Text>
  ) : null;

  if (isTable) return content;

  return (
    <div>
      <div className={styles.tinyDateKey}>
        <F id="pages.lead.fields.uuid" defaultMessage="ID" />
      </div>
      <div>{content}</div>
    </div>
  );
};

export default LeadUuid;
